import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getPhotoDetail, deletePhoto, updatePhoto } from "../../api/const";
import ActivitySearch from "../../components/const/Photo/ActivitySearch";
import PageHeader from "../../components/common/ui/PageHeader";

export default function Photo_view() {
  const { photoId } = useParams();
  const navigate = useNavigate();

  const [photo, setPhoto] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);

  const [form, setForm] = useState({
    title: "",
    activity_id: "",
    activity: "",
    description: "",
    date: "",
  });

  /** 데이터 로딩 */
  useEffect(() => {
    if (!photoId) return;
    getPhotoDetail(photoId)
      .then((data) => {
        setPhoto(data);
        setForm({
          title: data.title ?? "",
          activity_id: data.activity_id ?? "",
          activity: data.activity ?? "",
          description: data.description ?? "",
          date: data.date ? data.date.split("T")[0] : "",
        });
      })
      .finally(() => setLoading(false));
  }, [photoId]);

  /** 삭제 */
  const handleDelete = async () => {
    if (!window.confirm("삭제하시겠습니까?")) return;
    try {
      await deletePhoto(photoId);
      alert("삭제되었습니다.");
      navigate(-1);
    } catch (err) {
      alert("삭제 실패");
    }
  };

  /** 수정 저장 */
  const handleSave = async () => {
    try {
      const updated = await updatePhoto(photoId, {
        ...form,
        activity_id: form.activity_id,
      });
      setPhoto(updated);
      setIsEditing(false);
      alert("수정 완료");
    } catch (err) {
      alert("수정 실패");
      console.error(err);
    }
  };

  if (loading)
    return (
      <div className="p-6 text-center text-gray-500">로딩 중...</div>
    );

  if (!photo)
    return (
      <div className="p-6 text-center text-gray-500">
        사진 정보를 찾을 수 없습니다.
      </div>
    );

  return (
    <div className="p-6 space-y-6">

      {/* ====== 제목 ====== */}
      <PageHeader>시공사진 상세</PageHeader>

      {/* ====== 관리 버튼 ====== */}
      <div className="flex justify-end gap-2">

        {isEditing ? (
          <>
            <button className="btn-basic" onClick={() => setIsEditing(false)}>
              취소
            </button>
            <button className="btn-save" onClick={handleSave}>
              저장
            </button>
          </>
        ) : (
          <>
            <button className="btn-basic" onClick={() => setIsEditing(true)}>
              수정
            </button>
            <button className="btn-delete" onClick={handleDelete}>
              삭제
            </button>
            <button className="btn-basic" onClick={() => navigate(-1)}>
              뒤로가기
            </button>
          </>
        )}
      </div>

      {/* ====== 사진 영역 ====== */}
      <div className="bg-white border rounded-xl shadow-sm p-6 flex justify-center">
        {photo.file_url ? (
          <img
            src={photo.file_url}
            alt={photo.title}
            className="max-h-[500px] object-contain rounded-lg"
          />
        ) : (
          <div className="w-full h-64 bg-gray-100 flex items-center justify-center text-gray-400 rounded-lg">
            사진 없음
          </div>
        )}
      </div>

      {/* ====== 정보 영역 ====== */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

        {/* 제목 */}
        <div className="page-box md:col-span-2">
          <p className="text-muted mb-1">제목</p>
          {isEditing ? (
            <input
              className="input-base"
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
            />
          ) : (
            <p className="text-body-bold">{photo.title}</p>
          )}
        </div>

        {/* 작성자 */}
        <div className="page-box">
          <p className="text-muted mb-1">작성자</p>
          <p className="text-body-bold">{photo.created_by}</p>
        </div>

        {/* 액티비티 */}
        {/* <div className="page-box">
          <p className="text-muted mb-1">액티비티</p>
          {isEditing ? (
            <ActivitySearch
              projectId={photo.project}
              value={{ id: form.activity_id, name: form.activity }}
              onChange={(a) =>
                setForm({ ...form, activity_id: a.id, activity: a.name })
              }
            />
          ) : (
            <p className="text-body-bold">{photo.activity || "-"}</p>
          )}
        </div> */}

        {/* 날짜 */}
        <div className="page-box">
          <p className="text-muted mb-1">날짜</p>
          {isEditing ? (
            <input
              type="date"
              className="input-base"
              value={form.date}
              onChange={(e) => setForm({ ...form, date: e.target.value })}
            />
          ) : (
            <p className="text-body-bold">
              {photo.date ? new Date(photo.date).toLocaleDateString() : "-"}
            </p>
          )}
        </div>

        {/* 설명 */}
        <div className="page-box md:col-span-2">
          <p className="text-muted mb-1">설명</p>

          {isEditing ? (
            <textarea
              className="input-base resize-none h-32"
              value={form.description}
              onChange={(e) =>
                setForm({ ...form, description: e.target.value })
              }
            />
          ) : (
            <p className="text-body whitespace-pre-line">
              {photo.description || "설명 없음"}
            </p>
          )}
        </div>
      </div>

      

    </div>
  );
}
